import { ReactNode } from 'react';
import { useParams } from 'react-router';
import AnvaFlowProductsLayout from '@flows/src/components/flow-products/AnvaFlowProductsLayout';
import YellowhiveFlowProductsLayout from '@flows/src/components/flow-products/YellowhiveFlowProductsLayout';
import { useFlowInfo } from '@flows/src/api/getFlowInfo';

const FlowProductsLayout = ({ children }: { children: ReactNode }) => {
  const { flowId } = useParams<{ flowId: string }>();
  const { data: flowInfo } = useFlowInfo(flowId || '');

  if (flowInfo?.sub_type === 'YELLOWHIVE') {
    return (
      <YellowhiveFlowProductsLayout>{children}</YellowhiveFlowProductsLayout>
    );
  }

  return <AnvaFlowProductsLayout>{children}</AnvaFlowProductsLayout>;
};

export default FlowProductsLayout;
